import React from 'react';
import { useQuery } from '@apollo/client';
import * as FormStructure from '../FormStructure';
import { TmntText } from '../Common';
import { LOADING_MESSAGE, ERROR_MESSAGE } from '../Messages/Messages';
import DefaultPayment from '../CheckoutInfoBlock/DefaultPayment';
import { PAYMENT_INFO_TEXT_QUERY } from './operations';

export default function PaymentInfo() {
  const { data, loading, error } = useQuery(PAYMENT_INFO_TEXT_QUERY);

  if (loading) return LOADING_MESSAGE;
  if (error) return ERROR_MESSAGE;

  const {
    textFor,
    getDefaultPayment,
    getPaymentPageURL,
    hasProfileCompletionEnabled,
  } = data;

  const { myInfoPayment, myInfoPaymentDescription } = textFor;

  return (
    <FormStructure.FormWrapper>
      <FormStructure.FormGroup>
        <TmntText classNames="h2" tmnt={myInfoPayment} />
        <FormStructure.FormCell>
          <TmntText tmnt={myInfoPaymentDescription} />
        </FormStructure.FormCell>
        <FormStructure.FormCell>
          <DefaultPayment
            payment={getDefaultPayment}
            cardTitle={textFor?.paymentCardTitle}
            cardDefaultText={textFor?.paymentCardDefault}
            changeText={textFor?.changeText}
            noDefaultPayment={textFor?.noDefaultPayment}
            pageLink={getPaymentPageURL}
            selectPaymentText={textFor?.selectPayment}
            addPaymentText={textFor?.addPayment}
            hasProfileCompletionEnabled={hasProfileCompletionEnabled}
          />
        </FormStructure.FormCell>
      </FormStructure.FormGroup>
    </FormStructure.FormWrapper>
  );
}
